import React, { useEffect, useState, useMemo } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { NoticiaIndividualPage } from '../pages'
import { LoadingSpinner } from './LoadingSpinner'
import { useRelatedNews } from '../../hooks/useRelatedNews'
import { useNoticias } from '../../hooks/useNoticias'

// Tipo para o state de navegação
interface LocationState {
  from?: 'home' | 'noticias'
}

export function NoticiaPageWrapper() {
  const { id } = useParams()
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  
  // Captura a origem da navegação (de onde o usuário veio)
  // Reason: Usado para determinar o comportamento do botão "Voltar"
  const navigationOrigin = (location.state as LocationState)?.from || 'noticias'
  
  // Buscar todas as notícias da API
  const { data: noticiasData, loading: noticiasLoading } = useNoticias()
  
  // Encontrar a notícia específica pelo ID da URL
  // Reason: Buscamos pelo ID da URL para garantir que a notícia correta seja exibida,
  // independentemente de como o usuário chegou à página (clique, link direto, etc.)
  const noticia = useMemo(() => {
    if (!noticiasData?.list_noticias || !id) return null
    
    const noticiaId = parseInt(id, 10)
    return noticiasData.list_noticias.find(
      (n: any) => n.id === noticiaId
    ) || null
  }, [noticiasData, id])
  
  // Buscar notícias relacionadas para sincronizar o carregamento
  const { loading: relatedLoading } = useRelatedNews(noticia?.id)

  useEffect(() => {
    // Só definir loading como false quando todos os dados estiverem carregados
    if (!noticiasLoading && !relatedLoading) {
      setLoading(false)
    }
  }, [noticiasLoading, relatedLoading])

  // Scroll para o topo quando uma nova notícia é carregada
  useEffect(() => {
    if (noticia && !relatedLoading && !noticiasLoading) {
      // Scroll suave para o topo da página
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }, [noticia, relatedLoading, noticiasLoading])

  // Mostrar loading enquanto qualquer coisa estiver carregando
  if (loading || relatedLoading || noticiasLoading) {
    return <LoadingSpinner message="Carregando notícia e conteúdo relacionado..." />
  }

  // Caso a notícia não seja encontrada
  if (!noticia) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        background: '#f5f5f5',
        color: '#333'
      }}>
        <h2>Notícia não encontrada</h2>
        <p>A notícia com ID {id} não foi encontrada.</p>
      </div>
    )
  }

  return <NoticiaIndividualPage noticia={noticia} navigationOrigin={navigationOrigin} />
} 